export default "__VITE_ASSET__Bv8k72KS__"